import freenet from './assets/imap-providers/freenet.png';
import gmx from './assets/imap-providers/gmx.png';
import ionos from './assets/imap-providers/ionos.svg';
import mailboxOrg from './assets/imap-providers/mailboxorg.svg';
import posteo from './assets/imap-providers/posteo.png';
import strato from './assets/imap-providers/strato.svg';
import tOnline from './assets/imap-providers/tonline.svg';
import webDe from './assets/imap-providers/webde.png';

export type ImapProviderLogoKey =
  'GMX' | 'WEB_DE' | 'T_ONLINE' | 'IONOS' | 'STRATO' | 'MAILBOX_ORG' | 'POSTEO' | 'FREENET';

const LOGOS: Record<ImapProviderLogoKey, string> = {
  GMX: gmx,
  WEB_DE: webDe,
  T_ONLINE: tOnline,
  IONOS: ionos,
  STRATO: strato,
  MAILBOX_ORG: mailboxOrg,
  POSTEO: posteo,
  FREENET: freenet,
};

/** The official asset, unchanged: no radius, no border. T-Online ships only its wordmark (~4.9:1), so it keeps the logo height and its own width. */
export function ImapProviderLogo({
  provider,
  size,
}: {
  readonly provider: ImapProviderLogoKey;
  readonly size: 12 | 16 | 20;
}) {
  const wordmark = provider === 'T_ONLINE';

  return (
    <img
      src={LOGOS[provider]}
      alt=""
      aria-hidden
      height={size}
      width={wordmark ? undefined : size}
      style={{ height: size, width: wordmark ? 'auto' : size }}
      className="shrink-0"
    />
  );
}
